try {
  let trigger = document.getElementById('custom-form-submit');

  trigger.addEventListener('click', () => {
    const fieldCount = document.getElementById('formFieldCount').value;
    const formTitle = document.getElementById('formTitle').value;
    const formLocation = document.getElementById('formLocation').value;
    const confirmationSubject = document.getElementById('confirmationSubject')
      ? document.getElementById('confirmationSubject').value
      : '';
    const confirmationResponse = document.getElementById('confirmationResponse')
      ? document.getElementById('confirmationResponse').value
      : '';
    const fileItemsList = document.querySelectorAll('[type=file]');
    const fileItems = [];
    fileItemsList.forEach((fileItem) => fileItems.push(fileItem.files[0]));
    const files = fileItemsList ? fileItems : null;
    let formData = new FormData();
    let recipients = new Array();
    let fields = {};
    const pattern = new RegExp(
      '^[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}',
    );

    recipients.push('sysadmin@thenmusa.org');
    recipients.push(document.getElementById('formRecipient').value);

    for (let i = 0; i < fieldCount; i++) {
      let formField = 'formField' + i;
      let formFieldLabel = 'formFieldLabel' + i;
      fields[document.getElementById(formFieldLabel).innerHTML] =
        document.getElementById(formField).value;
    }
    formData.append('title', formTitle);
    formData.append('location', formLocation);
    formData.append('emails', recipients);
    formData.append('confirmationSubject', confirmationSubject);
    formData.append('confirmationResponse', confirmationResponse);
    formData.append('data', JSON.stringify(fields));
    if (files != null) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append('files[]', file);
      }
    }

    // Get customer email for automatic confirmation email
    let emailInput = document.querySelector(
      '.form-container form input[type="email"]',
    );
    let customerEmail = '';
    if (emailInput) {
      customerEmail = emailInput.value;
    }
    formData.append('customerEmail', customerEmail);

    let validEmail = true;
    let noErrors = true;

    // Get all email fields
    let emails = document.querySelectorAll(
      '.form-container form input[type="email"]',
    );

    // Add validation error if email is not formatted properly
    if (emails.length > 0) {
      let validationErrors = document.querySelectorAll(
        '#email-validation-error',
      );
      emails.forEach((email, i) => {
        if (email.value !== '') {
          pattern.test(email.value)
            ? validationErrors[i].classList.remove('show')
            : validationErrors[i].classList.add('show');
        }
        if (
          email.value === '' &&
          validationErrors[i].classList.contains('show')
        ) {
          validationErrors[i].classList.remove('show');
        }
      });

      for (let i = 0; i < validationErrors.length; i++) {
        if (validationErrors[i].classList.contains('show')) {
          validEmail = false;
          break;
        } else {
          validEmail = true;
        }
      }
    }

    // Get all form fields
    let formFields = document.querySelectorAll(
      '.form-container form input[type="text"], .form-container form input[type="file"], .form-container form input[type="email"], .form-container form input[type="date"], .form-container form textarea',
    );

    if (formFields.length > 0) {
      // Add required error if required field is blank
      let requiredErrors = document.querySelectorAll('.required-error');
      formFields.forEach((formFields, i) => {
        if (requiredErrors[i] !== undefined) {
          formFields.value === '' &&
          !requiredErrors[i].classList.contains('not-required')
            ? requiredErrors[i].classList.add('show')
            : requiredErrors[i].classList.remove('show');
        }
      });

      for (let i = 0; i < requiredErrors.length; i++) {
        if (requiredErrors[i].classList.contains('show')) {
          noErrors = false;
          document.querySelector('#required-errors').classList.add('show');
          break;
        } else {
          noErrors = true;
          document.querySelector('#required-errors').classList.remove('show');
        }
      }
    }

    const formNotBlank = Object.values(fields).some((value) => value !== '');

    if (formNotBlank === false) {
      document.querySelector('#blank-error').classList.add('show');
    } else {
      document.querySelector('#blank-error').classList.remove('show');
    }

    if (noErrors && validEmail && formNotBlank) {
      submitAsyncForm(formData);
    }
  });
} catch (e) {
  let trigger = null;
}

// Check file size
let uploadFiles = document.querySelectorAll(
  '.form-container form input[type="file"]',
);

if (uploadFiles.length > 0) {
  uploadFiles.forEach((uploadFile) => {
    uploadFile.onchange = function () {
      if (this.files[0].size > 5242880) {
        alert('Please upload a file smaller than 5 MB.');
        this.value = '';
      }
    };
  });
}

function submitAsyncForm(formFields) {
  let email_url = '/wp-content/themes/nmusa/svc/mail-endpoint.php';

  document.querySelector('.form-container form').classList.add('hide');
  document.getElementById('confirmation').classList.remove('hide');
  return fetch(email_url, {
    method: 'POST',
    body: formFields,
  });
}
